"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlexCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Flex.css");

var _styles = {
  "flex": "Flex__flex___iEdj3",
  "inline": "Flex__inline___2rC4r"
};

const styles = _bind.default.bind(_styles);

const formatToCSS = value => {
  return Array.isArray(value) ? value.map(val => `${val}px`).join(' ') : `${value}px`;
};

const FlexCell = (0, _mobxReact.observer)(({
  children,
  className,
  dataTestId,
  alignSelf,
  justifySelf,
  shrink,
  grow,
  basis,
  order,
  padding,
  style
}) => {
  const composedClassnames = (0, _bind.default)(styles('flex-cell'), className);
  const composedStyles = {
    alignSelf,
    justifySelf,
    flexShrink: shrink,
    flexGrow: grow,
    flexBasis: basis,
    order,
    ...style
  };

  if (padding) {
    composedStyles.padding = formatToCSS(padding);
  }

  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composedClassnames,
    style: composedStyles
  }, children);
});
exports.FlexCell = FlexCell;
const Flex = (0, _mobxReact.observer)(({
  children,
  className,
  dataTestId,
  inline,
  wrap,
  direction,
  alignItems,
  justifyItems,
  justifyContent,
  basis,
  gap,
  padding = 0,
  style,
  ...props
}) => {
  const composedClassname = (0, _bind.default)(styles('flex', {
    inline
  }), className);
  const composedStyles = { ...style,
    flexWrap: wrap,
    flexDirection: direction,
    alignItems,
    justifyItems,
    justifyContent,
    flexBasis: basis
  };

  if (padding) {
    composedStyles.padding = formatToCSS(padding);
  }

  if (gap) {
    composedStyles.gap = formatToCSS(gap);
  }

  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composedClassname,
    style: composedStyles,
    ...props
  }, children);
});

var _default = Object.assign(Flex, {
  Cell: FlexCell
});

exports.default = _default;